import ProductView from "../ProductView/ProductView";

export default function ProductPage({ productType }) {
  return <ProductView productType={productType}></ProductView>;
}